import * as React from 'react';

import {Divider} from 'shells/layout/divider';

import {SeeAllButton} from './see-all-button';
import {SubmissionsFrom} from './submissions-from';

import styles from './analytics-status.module.css';

type Props = {
    numActiveForms: number;
    numDraftForms: number;
    includeSeeAll?: boolean;
};

export function ConnectedFormsActiveBody(props: Props) {
    return (
        <div>
            <div className={styles.text}>
                Nutshell will track the activity of anyone who fills out an <strong>active</strong>{' '}
                form on your website.
            </div>
            <Divider variant='line--horizontal' />
            <div className={props.includeSeeAll ? undefined : styles['pad-bottom']}>
                <SubmissionsFrom
                    numActiveForms={props.numActiveForms}
                    numDraftForms={props.numDraftForms}
                />
            </div>
            {props.includeSeeAll ? <SeeAllButton /> : undefined}
        </div>
    );
}
